import { useContext, useState } from 'react';
import { ServiceResponse } from '../../../app/services/shared/interfaces';
import { toast } from 'react-toastify';
import ButtonCancelForm from '../../../components/buttons/ButtonCancelForm';
import ButtonSaveForm from '../../../components/buttons/ButtonSaveForm';
import { AppContext } from '../../../contexts/AppContext';
import useReactConfirmAlert from '../../../hooks/useReactConfirmAlert';
import { SocietyDocument } from '../../../app/models/Society';
import useSocietyDocumentService from '../../../app/services/hooks/useSocietyDocumentService';
import GeneralDocumentForm from '../../../components/GeneralDocumentForm';

interface Props {
    onSaved?: () => void;
    onCancel?: () => void;
    onError?: () => void;
    societyId: number;
    typeDocument: string;
}

const SocietyDocumentCreate = ({ onSaved, onCancel, onError, typeDocument, societyId }: Props) => {
    const { showLoading, hideLoading, changeAnimation } = useContext(AppContext);
    const [societyDocument, setSocietyDocument] = useState<SocietyDocument>({
        society_id: societyId,
        is_expire_date_indefinite: false,
        document_id: parseInt(typeDocument)
    });
    const [errorFields, setErrorFields] = useState<any>();
    const { fetchingStoreSocietyDocument, storeSocietyDocument } = useSocietyDocumentService();

    const store = () => {
        if (!societyDocument) {
            return;
        }
        if (showLoading) showLoading('loading', 'Guardando documento...');
        storeSocietyDocument(societyDocument, {
            onSuccess: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
                useReactConfirmAlert().successAlert({
                    title: 'Éxito',
                    message: response.message
                });
                toast.success(response.message, {
                    autoClose: 2500
                });
                if (onSaved) onSaved();
            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
                useReactConfirmAlert().errorAlert({
                    title: 'Error',
                    message: response.message
                });
            },
            onFieldError: (errorFields: ServiceResponse) => {
                if (hideLoading) hideLoading();
                setErrorFields(errorFields.data);
            }
        });
    };

    const cancel = () => {
        if (onCancel) onCancel();
    };

    return (
        <>
            <div className="row">
                <div className="col-12">
                    <GeneralDocumentForm
                        document={societyDocument}
                        setDocument={setSocietyDocument}
                        errorFields={errorFields}
                    />
                </div>
            </div>
            <hr />
            <div className="row justify-content-end">
                <div className="col-auto">
                    <ButtonCancelForm
                        callbackCancel={cancel}
                        locked={fetchingStoreSocietyDocument}
                    />
                </div>
                <div className="col-auto">
                    <ButtonSaveForm callbackSave={store} locked={fetchingStoreSocietyDocument} />
                </div>
            </div>
        </>
    );
};

export default SocietyDocumentCreate;
